import { render, staticRenderFns } from "./Osa009.vue?vue&type=template&id=750abfdc&scoped=true"
var script = {}
import style0 from "./Osa009.vue?vue&type=style&index=0&id=750abfdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750abfdc",
  null
  
)

export default component.exports